"use strict";

// src/index.ts
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.passwordStrengthValidator = exports.PASSWORD_RULES = void 0;
exports.PASSWORD_RULES = [{
  key: 'length',
  regex: /^.{8,128}$/
}, {
  key: 'lowerCase',
  regex: /[a-z]/
}, {
  key: 'upperCase',
  regex: /[A-Z]/
}, {
  key: 'specialChar',
  regex: /[!"#$%&'()*+,\-./:;<=>?@[\\\]^_`{|}~]/
}, {
  key: 'digits',
  regex: /[0-9]/
}];
/**
* Validates a password against common strength rules:
* - Minimum length 8 characters
* - At least one lowercase letter
* - At least one uppercase letter
* - At least one digit
* - At least one special character
*
* @param password - The password string to validate.
* @returns An object with failed rule keys set to true, or `null` if all rules pass.
*/
const passwordStrengthValidator = password => {
  const failedRules = {};
  exports.PASSWORD_RULES.forEach(rule => {
    if (!rule.regex.test(password)) {
      failedRules[rule.key] = true;
    }
  });
  return Object.keys(failedRules).length ? failedRules : null;
};
exports.passwordStrengthValidator = passwordStrengthValidator;